import { CriteriaGroupGroupElementsInner } from './CriteriaGroupGroupElementsInner.model';
import { DateTimeRangeValue } from './DateTimeRangeValue.model';

export interface CriteriaGroupXGroupElementsInner {
  /**
   * The array of Criteria Group or Criteria objects.
   */
  groupElements?: Array<CriteriaGroupGroupElementsInner>;
  /**
   * The owner of this group.
   */
  groupOwner?: string;
  /**
   * Whether this group is an OR group (true) or AND group (false).
   */
  isOr?: boolean;
  /**
   * The key for the criteria.
   */
  key: string;
  /**
   * The operator for the comparison.
   */
  operator: CriteriaGroupXGroupElementsInnerOperatorEnum;
  /**
   * The value (for single valued comparison objects).
   */
  value?: unknown;
  /**
   * The start of the range (for comparison operators that take a range).
   */
  valueFrom?: unknown;
  /**
   * The end of the range (for comparison operators that take a range).
   */
  valueTo?: unknown;
  /**
   * The value for relative date range option.
   */
  dateTimeRangeValue?: DateTimeRangeValue;
}

export enum CriteriaGroupXGroupElementsInnerOperatorEnum {
  Between = 'Between',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  Like = 'Like',
  UnLike = 'UnLike',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  IsSet = 'IsSet',
  NotSet = 'NotSet',
}
